const ENVIRONMENT = {
    API_HOST: 'https://internal.toppion.com.vn/api/',
    CULTURE_API_HOST: 'https://internal.toppion.com.vn/api/',
    API_HOST_DEV: '/api/',
    BASE_URL: 'https://internal.toppion.com.vn',
    CULTURE_BASE_URL: 'https://internal.toppion.com.vn',
    FILE_MANAGER: 'https://finder-dev.toppion.com.vn',
    ELEARNING_HOST: 'https://elearning.toppion.com.vn',
    /** Override local: CONFIG_NEXT_PUBLIC_AIHUB_API_BASE_URL trong .env.local */
    AIHUB_BASE_URL: 'https://staging-api.toppion.com.vn',
    AIHUB_API_HOST: 'https://staging-api.toppion.com.vn/api',
};

export default ENVIRONMENT;
